'use strict'
const merge = require('webpack-merge')
const base = require('./base')

module.exports = merge(base, {
  sendLabel: 'SEND',
  learnMore: 'Learn More',
  welcome: 'Hi, this is NKN\'s community support team. How are you today and what can we help?',
  dataRide:{
    banner1: {
      title:'dataRide',
      text:'<strong>dataRide</strong> is a decentralized PaaS (Platform as a Service) of fast, reliable, secure and low cost messaging and direct file transfer service for person to person, machine-human as well as machine-machine communication.'
    },
    banner2: {
      title:'dataRide',
      subTitle: 'Use Cases',
      text:`<ul>
<li style="list-style: inside">Chat and IM</li><li style="list-style: inside">IoT communication</li><li style="list-style: inside">Direct file transfer</li><li style="list-style: inside">Live chat support</li><li style="list-style: inside">Remote control of servers</li><li style="list-style: inside">Direct security camera control</li><li style="list-style: inside">Alert or update notification</li>
</ul>`,
      icon1:'Chat & IM',
      icon2:'IoT Comm',
      icon3:'Direct File Transfer',
      icon4:'Live Chat Support',
      icon5:'Remote Control',
      icon6:'Security Camera',
    },
    banner3: {
      title:'Developer Benefits',
      title1:'Simple & Lightweight SDK',
      text1:`<ul>
<li style="list-style: inside">Just a few lines of code</li><li style="list-style: inside">Mobile and web</li><li style="list-style: inside">Multiple SDK supported: Javascript, Go, Android, iOS</li>
</ul>`,
      title2:'Free to Try, Low Cost to Deploy',
      text2:`<ul>
<li style="list-style: inside">Eliminated needs to No need to setup and maintain your own infrastructure</li><li style="list-style: inside">Generous free trial tier for developers</li><li style="list-style: inside">Significantly loweringlower cost at scale</li>
</ul>`,
      title3:'Free & Open Source',
      text3:`<ul>
<li style="list-style: inside">No proprietary platform lock-in</li><li style="list-style: inside">No hidden backdoors</li><li style="list-style: inside">Large community support for new features and bug fixes</li>
</ul>`,
    },
    banner4: {
      title:'User Benefits',
      title1:'Reliable',
      text1:`<ul>
<li style="list-style: inside">Access data remotely;anywhere at your own convenience</li><li style="list-style: inside">Face no centralized servers downtime;service is always available</li>
</ul>`,
      title2:'Secure and Private',
      text2:`<ul>
<li style="list-style: inside">User communication is end-to-end and hop-by-hop encrypted</li><li style="list-style: inside">User data will not be stored in any centralized servers</li>
</ul>`,
      title3:'Fast Across the Globe',
      text3:`<ul>
<li style="list-style: inside">Proven fast file transfer rate, even/including internationally</li><li style="list-style: inside">Ride on the accelerated data paths, turbo charged speed</li>
</ul>`,
    },
    banner5: {
      title:'Apps Powered by dataRide',
      title1:'D-Chat',
      url1:'https://forum.nkn.org/t/introducing-d-chat-a-server-less-secure-and-private-chat-for-individuals-and-groups/1861',
      title2:'nMobile',
      url2:'https://forum.nkn.org/t/nmobile-pre-beta-community-testing-and-simple-guide/2012',
      title3:'nShell',
      url3:'https://forum.nkn.org/t/nkn-shell-nsh-a-new-kind-of-remote-shell-that-is-more-secure-and-convenient-than-ssh/1719',
      title4:'MaoPan App',
      url4:'',
    },
    banner6: {
      title:'Developers — Try dataRide Today!',
      text:'dataRide is live on NKN’s globally distributed network with up to 20,000 servers worldwide. Head to dataRide Learning Center and get started building your first application for FREE using dataRide!'
    },
  },
  dataRideSupport:{
    banner1: {
      title:'Customer Service Chat',
      subTitle: 'Powered by dataRide',
      text:'Customer Service Chat gives websites and applications an open and easy to use embedded chat solution to help you connect with your customers in real-time.'
    },
    banner2:{
      iconText1:'NKN Wallet',
      iconText2:'NKN Multi-client',
      title: 'Open SDK',
      text: 'NKN offers open source SDK’s in popular languages such as <a class="link" href="https://github.com/nknorg/nkn-multiclient-js" target="_blank">Javascript</a>, <a class="link" href="https://github.com/nknorg/nkn-sdk-go" target="_blank">go</a>, and <a class="link" href="https://github.com/nknorg/nkn-sdk-android" target="_blank">android</a> to make it easy to embed NKN’s Customer Service Chat solution into your next project.'
    },
    banner3:{
      title: 'D-Chat Customer Service Chat',
      subTitle: 'Management',
      text: 'Use the <a class="link" href="https://chrome.google.com/webstore/detail/d-chat/glnmkakdjcognfgonjfcklpmjiobijii" target="_blank">D-Chat plugin on Chrome/Brave browser</a> or nMobile on android to manage your customer service teams access and respond to messages in real-time.'
    },
    banner4:{
      title: 'Vue Model Source Code',
      text: 'Need sample code to help you build your chat bubble?  Check out our own <a class="link" href="https://github.com/iheron/vue-nkn-chat" target="_blank">vue model source code</a>.'
    },
    step1:{
      title: 'Integrate Customer Service Chat today in 3 easy steps',
      text: `<p>Import the nkn-wallet SDK and subscribe to your private group in the format of TOPIC.PublicKey.</p>
<br>
<p style="word-break: break-all; font-size: 9px;">ex. JasonsInsurance.25ac590eaca614a0ba4c4387d8514a0b54e948d120c6ff49564e7830c9dec929</p>`
    },
    step2:{
      text: `<p>Import the nkn-multiclient SDK.</p>
<br>
<p>The multiclient will get the NKN addresses of the customer support staff for the topic you subscribed in step 1.</p>
`
    },
    step3:{
      text: `<p>Add the ability to send and receive customer support messages</p>
<br>
<p>Now you are ready to go!</p>
`
    }
  },
  nCDN:{
    banner1:{
      title:'nCDN - A New Kind of Content Delivery Network',
      subTitle: 'A New Kind of Content Delivery Network',
      text: 'nCDN is a crowdsourced service offering accelerated performance for website, video, and rich media content.'
    },
    banner2:{
      title:'Best of both worlds',
      text: 'Our solution combines the best of traditional and P2P CDN solutions to offer reliable, low cost content delivery at scale.'
    },
    banner3:{
      title:'Largest shared network globally',
      text: 'nCDN is based on NKN’s proven decentralized network architecture with up to 20,000 nodes in more than 40 countries and regions globally.'
    },
    banner4:{
      title:'Simple self service portal',
      text: 'Our self service portal makes it easy to sign up and try out how nCDN can improve the performance of your website or application.'
    },
    banner5:{
      title:'The Right Choice',
      text: 'Our low cost shared network model together with NKN’s highly available global network makes nCDN the right choice for your content delivery needs.',
      icon1:'Low Cost',
      icon2:'Reliable',
      icon3:'Global Scale',
    },
    banner6:{
      title:'Website admins: try nCDN Beta today!',
      text: 'nCDN is currently in limited beta for selected enterprise and Small Medium Business customers. Please visit ncdn.io for a free trial and see how nCDN can help accelerate your website globally and at scale.',
      icon1:'Website acceleration',
      icon2:'Files cache',
      icon3:'Download acceleration',
    },
  },
  alert: {
    title: 'Click here to swap NKN token from NEP-5 to ERC-20',
    dlTip: 'Deadline: 23:59 UTC, March 28th, 2019',
    btn: 'Got it'
  },
  chat:{
    service: 'Customer Support Service'
  },
  header: {
    langSel: 'Language',
    nav: {
      tab1: '개발자',
      tab2: '채굴자',
      tab3: '파트너',
      tab4: '뉴스',
      tab5: '소개',
      tab6: 'Solution',
      tab7: 'nCDN',
      tab8: 'dataRide',
      tab9: 'Team',
      tab10: 'Roadmap',
      tab11: 'nMobile',
      tab12: 'Blog',
      tab13: 'nMobile-pro',
    }
  },
  footer: {
    nav: {
      title: 'Navigation',
      tab1: 'Developer',
      tab2: 'Miner',
      tab3: 'Partner',
      tab4: 'News',
      tab5: 'About'
    },
    community: {
      title: '커뮤니티',
      tab1: 'Telegram',
      tab2: 'Twitter',
      tab3: 'Reddit',
      tab4: 'Discord',
      tab5: 'Medium',
      tab6: 'YouTube',
      tab7: '포럼'
    },
    resource: {
      title: '자원',
      tab1: 'Github',
      tab2: '프로젝트 소개',
      tab3: 'Whitepaper',
      tab4: '로고 다운로드',
      tab5: 'Dev Doc',
      tab6: 'Core tech',
    },
    subscribe: {
      title: '이메일 구독하시면 더 많은 정보를 얻으실 수 있습니다:',
      inputph: '이메일 주소:',
      btn: '구독',
      success: 'You had subscribed NKN news successfully!',
      notice: 'Don’t miss out on the newest NKN events!'
    },
    copyright: ' Copyright © 2017-2020 NKN | All rights reserved'
  },
  home: {
    press: 'Press',
    header: {
      title: `NKN: 탈중앙화 인터넷을 위한 네트워크 인프라`,
      desc: 'NKN은 새로운 P2P 네트워크 연결 프로토콜 및 생태계입니다. NKN은 새로운 퍼블릭 블록체인을 기반으로 합니다. 우리는 인터넷 사용자가 네트워크 연결을 공유하고, 사용하지 않는 대역폭을 활용하게끔 경제적 보상을 제공합니다. NKN의 열린, 효율적인, 탄탄한 네트워크 인프라는 응용프로그램 개발자가 탈중앙화 인터넷을 구축할 수 있게 합니다. 이렇게 되면 모든 사람이 안전하고, 저렴하고, 어디에서나 접근 가능한 연결을 사용할 수 있습니다.',
      btn1: '테스트넷 체험하기',
      btn2: 'Try MainNet',
      news: 'NEWS: Introducing nCDN',
    },
    swiper: {
      title1: 'NKN이 국제거래소인 Bittrex에 상장했습니다.',
      title2: 'Mainnet V0.9 Beluga Released',
      title3: 'NKN 토큰 스왑: ',
      title3sub: 'NEP-5에서 ERC-20으로 스왑',
      title4: 'NKN이 한국 거래소 업비트에 상장했습니다.',
      title5: '',
      content1sub1: 'NKN/BTC 거래쌍(trading pair)으로 거래할 수 있습니다:',
      content1sub2: '<a href="https://international.bittrex.com/Market/Index?MarketName=BTC-NKN" target="_blank">https://international.bittrex.com/Market/Index?MarketName=BTC-NKN</a>',
      content2: `Mainnet V0.9 Beluga is released on March 31, 2019. Beyond scalable networking and consensus, also featuring ledger and security enhancements. Last major release before final Mainnet v1.0 Narwhal due June.`,
      content3sub1: 'NEP-5 NKN토큰은 ERC-20 토큰과 1:1로 스왑됩니다. ',
      content3sub2: '2019년 1월 한 달간 gate.io에서 자동 스왑을 지원합니다.',
      content3sub3: '개인지갑 (Private Wallet)에 토큰을 가지고 있다면 NKN의 공식 웹기반 토큰 스왑 툴을 사용하여 스왑할 수 있습니다.',
      content4sub1: 'NKN/BTC 거래쌍(trading pair)으로 거래할 수 있습니다:',
      content4sub2: '<a href="https://sg.upbit.com/exchange?code=CRIX.UPBIT.BTC-NKN" target="_blank">https://sg.upbit.com/exchange?code=CRIX.UPBIT.BTC-NKN</a>',
      content5: '우리는 Web3Infra 연맹 런칭을 선포하게 되어 매우 기쁩니다. Web3Infra는 탈중앙화와 공유경제에서 번창하고 있는 개방된 Web 3.0 개발 플랫폼입니다. NKN은 Bluzelle및 NOIA Network, Portal Network와 함께 창립멤버 중 하나로 함께하게 되어 영광입니다.',
    },
    walletAndExplorer: {
      title: 'Blockchain Wallet & Explorer',
      title1: 'Official NKN Wallet',
      subTitle1: 'Official NKN Wallet for Mainnet',
      title2: 'Official NKN Explorer',
      subTitle2: 'Official NKN Explorer for Mainnet',
      title3: 'NKN Explorer by NKNx',
      subTitle3: 'Blockchain explorer and node check',
      title4: 'nStatus',
      subTitle4: 'A simple NKN node checker',
    },
    wordmap: {
      title: 'NKN is building the world’s largest blockchain network',
      //nodeDistribution: '<span class="full-node-title">풀노드 : </span><span class="full-node-count">{total}</span><span class="full-node-team">(NKN 팀이 운영하는 노드는 단 {team} 개입니다.)</span>',
      nodeDistribution: '<span class="full-node-title">풀노드 : </span><span class="full-node-count">{total}</span>',
      nodeByRegions: 'NKN 노드를 운영하는 국가 수: {count} (<a href="/kr/miner/" target="_self">채굴자로써 참여하기</a>)',
      details: 'NKN full nodes all around the world, with more nodes than Bitcoin network.'
    },
    whynkn: {
      title: '왜?',
      subtitle1: '클라이언트-서버 모델은 값비싸고, 복잡하고 실패 및 공격에 약합니다.',
      subtitle2: '비효율적인 네트워크 사용은 네트워크 연결이 좋지 않거나 끊김 현상을 초래합니다.',
      subtitle3: '블록체인 시스템의 중앙화는 신뢰를 약화시킵니다.',
      subContent1: `현재 대부분의 통신은 중앙화된 서버를 거칩니다. 중앙화된 서버는 차단되거나 방해받고, 해킹당하고, 다른 사람이 정보를 엿볼 수 있습니다.`,
      subContent2: `현재 인터넷은 피크 트래픽 (Peak Traffic)을 위해 설계되어 있습니다. 대부분의 시간에는 네트워크가 충분히 이용되지 않고 있으며, 사용하지 않은 대역폭이 초마다 낭비되고 있습니다. `,
      subContent3: `현재 선도하는 블록체인 프로젝트는 성능 (초당 거래 건수)를 높이기 위해 합의 알고리즘을 소수의 노드에만 집중하고 있습니다. 이는 분산된 신뢰와 보안을 희생하고, 진정한 공개형(permissionless) 블록체인 시스템의 강점을 약화합니다. `
    },
    nknAdvantage: {
      title: 'NKN의 장점',
      subtitle1: '수백만 개의 노드:',
      subtitle2: '집중된 빠른 속도:',
      subtitle3: '지연 속도 감소:',
      subtitle4: '서버 없음:',
      subtitle5: '고유 및 세게적 ID:',
      subtitle6: '추가 보안 & 사생활 보호:',
      subContent1: '수평적으로 확장할 수 있고 임의 개수의 합의 노드를 지원하는 새로운 MOCA 합의 알고리즘입니다.우리의 테스트 네트워크는 비트코인, 이더리움 다음으로 많은 5,878 합의 노드를 가지고 있습니다.',
      subContent2: '노드와 클라이언트는 여러 경로의 속도를 집합한 속도를 사용할 수 있습니다. 네트워크에 NKN 노드를 추가하면 전체 네트워크의 처리량을 수평적으로 확장할 수 있습니다.',
      subContent3: '실시간 3D 게임 및  AR/VR, IoT를 포함한 모든 응용프로그램을 지원합니다.에지 컴퓨팅과 최적 라우팅을 지원합니다. NKN의 데이터 전송은 오프체인이며, 합의된 속도에 제한 받지 않습니다.',
      subContent4: '완전히 탈중앙화하고 P2P로 진행하기 때문에, 중앙화된 서버를 개발하고 운영할 필요가 없습니다. 복잡성과 비용을 현저하게 줄이고, 단일지점장애 문제가 발생하지 않으며,해킹을 대비한 중앙 허니팟을 없앨 수 있습니다.',
      subContent5: '고유 NKN 주소로 언제, 전 세계 어디서나 서비스할 수 있습니다;사람들이 응용프로그램과 서비스를 발견하고 찾을 수 있게끔 도와줍니다.',
      subContent6: '공개키 인프라 또는 제3자 증명 없이 End-to-end 및 Hop-by-hop 암호화합니다.'
    },
    nknProduct: {
      title: 'NKN 응용프로그램',
      applications: {
        title: 'dApps',
        tab1: '우주 고양이, 3D multi-player action game without servers',
        tab2: 'NKN 채팅, 탈중앙화 인스턴트 메신저',
        tab3: 'Smart home IoT, secure NKN-based e2e communication solution for massive IoT devices.',
        tab4: 'D-chat, decentralized chat based on NKN Pub/Sub messaging',
        tab5: 'Tuna, open marketplace for software services',
        tab6: 'NKN Shell (nsh), more secure and convenient than SSH',
        tab7: 'NKN d-FTP, High throughput file transfer',
      },
      wallet: {
        title: '지갑 & 대시보드',
        tab1: 'NKN 공식 지갑',
        tab2: 'NKNWallet.io by community'
      },
      dashboard: {
        title: '대시보드',
        tab1: 'NKN 공식 대시보드',
        tab2: 'nknx.org 커뮤니티 대시보드',
        tab3: '커뮤니티의 새로운 대시보드',
        tab4: 'Node and wallet tracker'
      },
      flagshipProducts: {
        title: 'Flagship Products',
        tab1: '새로운 종류의 CDN',
        tab2: 'pubsub - 턀중앙화 메세지 & pub/sub',
      }
    },
    platformServices: {
      platformServicesTitle: 'NKN Platform Services',
      txtTitle:'Communication as a Service (CaaS) Solution',
      txtDesc: 'open, dependable, fast, scalable platform services for enterprises and developers',
      nPubSub: {
        title:'dataRide',
        desc: `<strong>dataRide</strong> is a decentralized PaaS (Platform as a Service) of fast, reliable, secure and low cost messaging and direct file transfer service for person to person, machine-human as well as machine-machine communication.
<ul>
<li style="list-style: inside"><a href="https://dataride.nkn.org/chat/" target="_blank"><strong>Chat and IM</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/iot/" target="_blank"><strong>IoT communication</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/filetransfer/" target="_blank"><strong>Direct file transfer</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/support/" target="_blank"><strong>Live chat support</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/remotecontrol/" target="_blank"><strong>Remote control of servers</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/camera/" target="_blank"><strong>Direct security camera control</strong></a></li><li style="list-style: inside"><strong>Alert or update notification</strong></li>
</ul>`
      },
      nCDN: {
        title:'nCDN - A New Kind of Content Delivery Network',
        subtitle: 'A New Kind of Content Delivery Network',
        desc: `nCDN is a crowdsourced service offering accelerated performance for website, video, and rich media content.`
      }
    },
    communityDApp: {
      title: 'dApps based on NKN',
      nMobile:{
        title: 'nMobile',
        text: `A mobile app that combines NKN wallet, D-Chat, NKN news, mining node monitoring, and IoT communication and control.`,
        url: 'https://nmobile.nkn.org/downloads/nMobile.apk',
        betaUrl: 'https://nmobile.nkn.org/downloads/nMobile-beta.apk'
      },
      nMobilePro: {
        title: 'nMobile Pro',
        text: `A mobile app that combines NKN wallet, D-Chat, NKN news, mining node monitoring, and IoT communication and control.`,
        url: 'https://nmobile.nkn.org/downloads/nMobile-pro.apk',
      },
      dChat: {
        title: 'D-chat',
        text: 'Serverless chat for public and permissioned groups, secure and private 1-on-1 chat, as well as communicate with machines.',
        url:'https://forum.nkn.org/t/introducing-d-chat-a-server-less-secure-and-private-chat-for-individuals-and-groups/1861'
      },
      nFtp:{
        title: 'nFTP',
        text: 'Secure and high speed file transfer service directly between any clients without any servers.',
        url:'https://forum.nkn.org/t/nkn-d-ftp-high-throughput-file-transfer-using-nkn-client/1711'
      },
      nShell:{
        title: 'nShell',
        text: 'A new kind of remote shell that is more secure and convenient than ssh.',
        url:'https://forum.nkn.org/t/nkn-shell-nsh-a-new-kind-of-remote-shell-that-is-more-secure-and-convenient-than-ssh/1719'
      }
    }
  },
  developer: {
    title: '개발자 포털',
    clientIntro: {
      title: '개발자를 위한 소개 자료',
      vtitle1: 'NKN 프로젝트 소개',
      vtitle2: 'NKN 클라이언트 SDK 소개'
    },
    dapp: {
      title: 'Example DApps',
      title2:'Platform Services',
      subtitle1: '우주 고양이',
      subtitle2: 'NKN 채팅',
      subtitle3: 'nknx.org',

      subtitle5: '스마트 홈 IoT',
      subtitle6: 'D-Chat',
      subtitle7: 'nCDN',
      subtitle8: 'IOT',
      subtitle9: 'dataRide',
      subtitle10: 'TUNA',
      subtitle11: 'Nanopay',
      subtitle12: 'NKN Wallet',
      subtitle13: 'NKN Explorer',
      subtitle14: 'Node and wallet tracker',
      subtitle15: 'NKN Shell',
      subtitle16: 'd-FTP',
      subtitle17: 'NKN multi-client SDK',

      subContent1: '3D multi-player action game without servers.',
      subContent2: 'A decentralized instant messenger built with NKN Client SDK.',
      subContent3: 'Community built All-in-one Dashboard with token market data, blockchain explorer, wallet, miner node manager and asset tracker. Now in 6 languages.',
      subContent8: 'Secure NKN-based e2e communication solution for massive IoT devices.',
      subContent9: 'Pub/Sub real-time messaging.',
      subContent10: 'Open marketplace for software services.',
      subContent11: 'Efficient nano payment channel.',
      subContent12: 'Official NKN Wallet for Mainnet.',
      subContent13: 'Blockchain explorer and node check.',
      subContent14: 'Miner portal, Node and Wallet tracker.',
      subContent15: 'More secure and convenient than SSH.',
      subContent16: 'High throughput file transfer.',
      subContent17: 'Improving packet reliability and latency.',

      subContent1Link1: '프레젠테이션',
      subContent1Link2: '다운로드 링크',
      subContent2Link1: '사용해보기',
      subContent3Link1: '링크',
      subContent3Link2: 'GitHub',
      subContent3Link3: '프로젝트 관리',

      subContent5: 'Secure NKN-based e2e communication solution for massive IoT devices.',
      subContent5Link1: '더 많은 정보 보러 가기',
      subContent6: 'Decentralized chat based on NKN Pub/Sub messaging.',
      subContent6Link1: '사용해보기',
      subContent6Link2: 'Gitlab',
      subContent7: 'New Kind of CDN using decentralized edge nodes.',
    },
    coreTech: {
      title: '핵심 기술',
      subtitle1: '탈중앙화한 데이터 전송 망(DDTN）',
      subContent1: 'NKN은 Chord 분산 해시 테이블을 기반으로 하여 다이내믹 토폴로지와 라우팅을 유지보수하고, 수백만 고객에게 언제든지 가입하고 떠날 수 있는 서비스를 제공할 수 있습니다. 고유 NKN 주소는 노드와 클라이언트를 식별하는 데에 사용되고, TCP/IP에서 오버레이 네트워크를 제공합니다. 데이터가 중앙 서버를 거치지 않고 한 클라이언트에서 다른 클라이언트로 전송될 수 있습니다.',
      subtitle2: '릴레이증명방식 (PoR)',
      subContent2: 'NKN은 라우트 상 노드의 릴레이 증명을 위해 서명 체인 (Signature Chain)을 설계하였습니다. 이는 검증이 가능하고, 조작 및 위조가 불가하고, 공격에 강한 수준의 안전한 데이터 전송을 가능하게끔 합니다.',
      subtitle3: 'MOCA: 확장성이 높은 합의 알고리즘',
      subContent3: 'NKN은 셀룰러 오토마타 (Cellular Automota)와 이징 모델 (Ising modeal)을 기반으로 확장성이 높은 합의 알고리즘인 Major Vote Cellular Automata (MOCA)를 설계하였습니다. NKN은 MOCA를 수백만 개의 노드에 걸쳐 차세대 블록체인과 동등계층 네트워크 (peer-to-peer network)에서 구현하였습니다. ',
      subtitle4: 'Token/incentive distribution mechanism',
      subContent4: 'NKN’s economic model will provide token rewards for participants who help relay traffic for other users. In addition, expected mining reward will also be proportional to the amount of data that participants help relay. These economic incentives will encourage the community to build and share the network.'
    },
    bounty: {
      title: '현상금 프로그램',
      subtitle1: '$ $ $',
      subContent1: '오픈소스 인스턴트 메시징 앱을 NKN에 포팅 (porting)해 주실 분을 찾습니다.  DAU가 500을 초과한 최고의 앱에 대해서 100,000 NKN을 약속드립니다.',
      subContent1Link1: '링크'
    },
    resources: {
      title: '개발자용 자원',
      subtitle1: 'Github 코드',
      subtitle2: '문서 & 도움말',
      subtitle3: '도구',
      subtitle4: '커뮤니티가 만든 Client SDK'
    }
  },
  miner: {
    title: '채굴자 포털',
    miningIntro: {
      title: 'NKN Mining Intro',
      vtitle: 'NKN 채굴 소개 1분 영상'
    },
    started: {
      title: '시작하기',
      subtitle1: '채굴 소개 문서 (영어)',
      subtitle2: '채굴 소개 문서 (중국어)',
      subtitle3: '채굴 소개 문서 (다른 언어)',
      sub1li1: '컴파일, 링크를 포함한 통합 가이드',
      sub1li2: 'DigitalOcean으로 5분만에 NKN 채굴자를 설치하고, 두 달 동안 무료로 실행하세요',
      sub1li3: '윈도우 10에서 NKN 채굴자를 설치하고 자동으로 실행하는 방법',
      sub1li4: 'Rasberry pi로 NKM (New Kind of Miner)를 만드는 방법',
      sub1li5: 'Rasberry pi를 NKN 채굴기로 설정하는 스크립트',
      sub2li1: '채굴 중국어 가이드',
      sub2li2: '채굴 일본어 가이드 ( Digital Ocean cloud)',
      sub2li3: '채굴 일본어 가이드 (Rasberry Pi)'
    },
    software: {
      title: 'NKN 채굴 소프트웨어 다운로드',
      subtitle1: '개인 노트북 또는 데스크톱을 사용하시는 경우, GUI 원클릭 채굴 프로그램을 다운로드 받으세요.',
      subtitle2: '클라우드 서버 또는 Embedded Device를 사용하시는 경우 수동으로 채굴 프로그램을 다운로드 받고 설치해주세요.',
      githubBtn: 'Mining SW download',
      tutorial: 'Tutorial',
      pcMining: 'PC Mining',
      n1Mining: 'N1 Mining',
      raspberryPiMining: 'Raspberry pi mining',
      oneClickMining: '1-click for cloud platform Mining'
    },
    tools: {
      title: '채굴 도구와 자원',
      subtitle1: '공식 테스트넷 nkn.org',
      subtitle2: '커뮤니티가 구축한  nknx.org',
      subtitle3: '커뮤니타가 구축한  새로운 대시보드'
    }
  },
  partner: {
    title: '파트너 포털',
    topology: {
      nodeBC: '블록체인 프로젝트',
      nodeCloud: '클라우드 서비스 플랫폼',
      nodeTelco: 'Enterprise',
      nodeApp: '응용프로그램 개발자'
    },
    more: {
      title: '생태계 매력',
      subtitle1: '네트워크 로밍',
      subContent1: '언제 어디서나, 어떤 장비로도 NKN 네트워크에 연결할 수 있습니다. NKN은 항상 네트워크 개방성, 진정한 P2P 연결 및 확장성을 키울 것입니다.',
      subtitle2: '공유 네트워크 자원',
      subContent2: '개인은 사용하지 않는 네트워크 자원을 다른 사람과 공유하고, 보상을 받습니다. 이러한 인센티브 모델로, NKN은 사용자 경험을 개선할 뿐만 아니라, 더 많은 노드가 네트워크에 들어오면서 더욱 안정적이고 공격에 강해집니다.',
      subtitle3: '네트워크 공동 구축',
      subContent3: 'NKN은 개인과 기업이 새로운 장비 구축 및 네트워크 인프라 업그레이드, 네트워크 용량 증가, 네트워크 연결 및 신뢰성을 높이는 것을 장려합니다. '
    },
    list: {
      title: 'Partners',
      research: {
        title: '연구 파트너',
        crypticTitle: 'Cryptic Labs',
        crypticText: `NKN은 Cryptic labs와 협업하여 NKN의 블록체인 기술을 뒷받침하는 암호학 연구를 추진하고 있습니다.
        또한, Whitfield Diffie 교수가 팀의 고문을 맡고 있습니다.
        `
      },
      telco: {
        title: 'Enterprise',
        tipTitle: 'TIP',
        tipText: `NKN은 텔레콤 전기 통신 인프라 프로젝트 (Telecom Infrastructure Project, TIP)에 참여하였습니다. NKN은 엣지 컴퓨팅 (Edge Compute) 및 Open cellular, TIP 커뮤니티 랩 등 프로젝트에 토큰화한 연결 프로토콜과 경제적 보상을 도입하여, 혁신을 촉진하고 새로운 전기 통신 솔루션이 채택되는 것을 지원합니다. `,
        onfTitle: 'ONF',
        onfText: `NKN은 오픈 네트워크 재단 (Open Network Foundation, ONF)에 참여하였습니다. ONOS, Stratum 등 프로젝트에 참여하여 소프트웨어 정의 네트워크 (Software Defined Network, SDN)를 향상시키고, 오픈 소스 인프라 솔루션을 효율적으로 사용하게끔 토큰화한 경제적 보상을 제공합니다.`,
        dpTitle: 'Datapace',
        dpText: `NKN은 Datapace와 파트너십을 맺고 NKN의 세계적 동등계층 (peer-to-peer) 네트워크에 Datapace의 탈중앙화 데이터 시장과 센서 생태계를 제공합니다.`
      },
      cloud: {
        title: '클라우드 컴퓨팅 플랫폼',
        gcTitle: 'Google Cloud',
        gcText: `NKN software is available on Google Cloud Marketplace for easy setup and deployment on the Google Cloud Platform.`,
        awsTitle: 'AWS',
        awsText: `NKN software is available on AWS Marketplace for easy setup and deployment on AWS Cloud.`,
        dcTitle: 'Digital Ocean',
        dcText: `NKN은 Digital Ocean 마켓의 첫 블록체인 프로젝트가 되어 매우 기쁩니다.
        Digital Ocean 플랫폼에서 NKN 소프트웨어가 쉽게 원클릭 다운로드할 수 있습니다.
        `
      },
      developer: {
        title: '개발자',
        pnTitle: 'Portal Network',
        pnText: `NKN is collaborating with Portal Network to develop a NKN Name Service (NNS) for the NKN Network.`,
        o3Title: 'O3 Labs',
        o3Text: `NKN is working with O3 Labs to bring NKN token to the O3 mobile wallet.`,
        w3iTitle: 'Web3infra alliance',
        w3iText: `Web3Infra Alliance intend to unify the decentralized ecosystem by integrating different Web3 components to create an open and unified environment`,
      },
      blockchain: {
        title: '블록체인 프로젝트',
        IoTeXTitle: 'IoTeX',
        IoTeXText: `
        IoTeX is the auto-scalable and privacy-centric blockchain platform for the Internet of Things (IoT).  IoTeX is developing several in-house innovations to push the frontier of blockchain 3.0, including a blockchains-in-blockchain architecture for heterogeneous computing, Roll-DPoS consensus mechanism for high scalability, and lightweight privacy-preserving techniques.`,
        UUUTitle: 'UUU',
        UUUText: `
        U Network is the first quality content blockchain and the first global decentralized content publishing and valuation platform. U Network was designed to provide a prediction market on content value for the users in order to establish a reasonable pricing mechanism, to help users discover valuable content and information, and to tackle the incentive issue for quality content.`,
        dxcTitle: 'DxChain',
        dxcText: `
        DxChain is the world's first decentralized big data and machine learning network powered by a computing-centric blockchain.  As a public chain, DxChain aims to design a platform to solve computation of big data in a decentralized environment.  For simplicity, DxChain can also store and trade big data, so as to make data more valuable with the computation.`
      },
      equipment: {
        title: '네트워크 장비 공급 업체',
        nokiaTitle: 'Nokia',
        nokiaText: 'NKN은 노키아의 오픈 생태계에 속해 있으며, Nokia Open Innovation Challenge 2018에 참가하여 혁신자로 인정받았습니다.NKN은 노키아의 DIA (Digital Innovation Acceleration) 조직의 인큐베이터 프로젝트인 Datapace와 협업하고 있으며, NKN의 세계적 동등계층 (peer-to-peer) 네트워크에 Datapace의 탈중앙화 데이터 시장과 센서 생태계를 제공합니다. '
      },
      chinaMobile: {
        title: 'China Mobile',
        text: 'NKN has signed a collaboration agreement with a division of China Mobile in Southern China: covering key areas such as cloud computing, network, and blockchain. The first real use case will be content delivery over China Mobile’s edge data center.'
      },
      netnic: {
        title: 'NETNIC',
        text: 'NKN signed a commercial contract with NETNIC for New Kind of Content Delivery Service, nCDN. By working together with NKN, NETNIC can continue to improve its content delivery services for its clientele of more than 100,000 enterprise customers.'
      }
    }
  },
  news: {
    title: '뉴스',
    socialMedia: {
      title: '소셜 미디어',
      newsList: {
        advisor: {
          title: 'Founder and CEO Stephen Wolfram Joins NKN As Technical Advisor',
          time: 'Dec 18, 2018',
          desc: 'NKN announces Dr. Stephen Wolfram, founder and CEO of Wolfram Research, has joined the NKN project as technical advisor. Wolfram will provide technical guidance and entrepreneurial mentorship to the NKN project.'
        },
        nokia: {
          title: 'NKN Finalist for Nokia Open Innovation Challenge 2018',
          time: 'Dec 12, 2018',
          desc: 'NKN was chosen as one of the 6 finalists out of over 300 applicants in the Nokia Open Innovation Challenge 2018 and was invited to present at the awards ceremony on December 6th in Murray Hill, NJ, all expenses paid by Nokia.'
        },
        redemption: {
          title: 'NKN Bi-weekly Report December 4',
          time: 'December 17, 2018',
          desc: `• Early Redemption for NKN test tokens
          • NKN Finalist for Nokia Open Innovation Challenge 2018
          • AMA and video interview for Chinese speaking community`
        }
      }
    },
    video: {
      title: '영상'
    }
  },
  about: {
    titleText: `구글 및 노키아, 퀄컴, 바이두, 온체인에서 네트워크와 블록체인을 수년간 구축한 사업가와 엔지니어가 모여, 2018년 1월 NKN을 설립하였습니다.
    블록체인이 기존 네트워크 비즈니스와 다른 기술적, 경제적 혁신을 제공한다는 점이 팀의 이념입니다.
    팀은 캘리포니아 실리콘 밸리와 중국 베이징 총 두 곳에 사무소가 있습니다.
    `,
    map: {
      tag1: 'Silicon Valley Office',
      tag2: 'Beijing Office'
    },
    member: {
      title: 'Core team & Advisors',
      yanbo: {
        name: 'Yanbo Li',
        position1: '창립자 | 전략 & 시스템 아키텍처',
        position2: '전 Onchain 공동 창립자',
        intro: `오픈소스 지지자, 리눅스 커널 네트워크 서브시스템 코드 컨트리뷰터 (contributor)
        블록체인 시스템 아키텍처와 개발 경험 다수 보유
        퀄컴, 노키아에서 10년 이상 P2P/Mesh 네트워크 프로토콜 개발 경험 보유
        `
      },
      bruce: {
        firstname: 'Zheng',
        lastname: `“Bruce” Li`,
        position1: '공동 창립자',
        position2: '전략 & 운영',
        intro: `노키아와 구글에서 내부 스타트업 프로젝트를 담당하고, 프로젝트를 성공적으로 시장에 출시
        통신 혁신 전문가, 전략 및 사업개발 전문
       `
      },
      yilun: {
        name: `Yilun Zhang`,
        position1: '공동 창립자',
        position2: '핵심 연구 & 개발',
        intro: `캘리포니아대학교 샌디에고 캠퍼스 물리학 박사. 베이징대학교 물리학 학사.
        셀룰러 오토마타, 이징 모델 (Ising Model), 분산 정보 처리 (distributed information processing) 영역 전문가.
        풀스택 개발자
        `
      },
      allen: {
        name: `Allen Dixon`,
        position1: '사업개발',
        position2: '준법감시',
        intro: `기술과 사업을 통합하여 능숙하게 새로운 기회를 창출하는 수석 사업개발 전문가
        20년이 넘는 통신 분야 경험 보유
        애플 및 아마존, 다수 스타트업 등과의 파트너십 담당
        `
      },
      diffle: {
        name: 'Whitfield Diffie',
        honor1: '공개키 암호학 발명자 (Diffie-Hellman)',
        honor2: '2015 투링상 수상자',
        honorlist: {
          row1: '영국 학술원 회원',
          row2: 'National Academy of Engineering 회원',
          row3: '스위스취리히연방공과대학 명예박사',
          row4: 'Marconi Foundation 회원',
          row5: '로얄홀러웨이런던대학교 박사',
          row6: '1981년 IEEE Donald G.Fink 논문상 ',
          row7: '프랑클린 연구소 Louis E. Levy 메달',
          row8: 'IEEE 정보 이론 학회 Golden Jubilee 기술혁신상',
          row9: '2010년 IEEE Richard W.Hamming 상'
        }
      },
      wolfram: {
        name: 'Stephen Wolfram',
        honor1: 'Wolfram Research 창립자 및 CEO',
        honorlist: {
          row1: '1979년 캘리포니아공대 이론물리학 박사',
          row2: '1981년 MacArthur Genius Award 수상',
          row3: '1983-1986년 프린스턴고등연구소 멤버',
          row4: 'Center for Complex Systems Research 창립자',
          row5: '일리노이대학교 어버너-샴페인캠퍼스 수학, 컴퓨터공학, 물리학 외래 교수',
          row6: 'Journal of Complex Systems 창립자',
          row7: '미국과학진흥회 회원',
          row8: '베스트셀러 A New Kind of Science 저자',
          row9: '2012년 SXSW 인터랙티브 디지털 커뮤니티 가장 큰 영향력 상 수상, 이벤트 발표자',
          row10: '미국수학회 출범 멤버',
          row11: '수학 박물관 Trustee 창립'
        }
      }
    },
    roadmap: {
      title: '로드맵',
      testnetFlag: 'TESTNET',
      mainnetFlag: 'MAINNET',
      firefox: {
        time: 'June 16th, 2018',
        title: 'V0.1 "Firefox" 배포',
        desc: '모든 핵심 서브시스템이 같이 동작하는, 세계적 노드에 걸친 첫 라이브 테스트넷'
      },
      lemur: {
        time: 'August，2018',
        title: 'V0.3 "Lemur" 배포',
        desc: '확장성, 효율성 최적화, SDK alpha 배포'
      },
      koala: {
        time: 'October，2018',
        title: 'V0.5 “Koala” 배포',
        desc: '공격 저항성 제고, 테스트넷 규모 확장, SDK beta 배포'
      },
      meerkat: {
        time: 'January，2019',
        title: 'V0.7 “Meerkat” 배포',
        desc: '모든 기능을 완전히 구현하고, 완전한 성능을 갖춘 테스트넷, SDK v1.0  배포'
      },
      beluga: {
        time: 'March，2019',
        title: 'V0.9 “Beluga” 배포',
        desc: '테스트넷 상태를 기반으로 NKN의 핵심 기능 추가 개발 및 개선'
      },
      narwhal: {
        time: 'June，2019',
        title: 'V1.0 “Narwhal” 배포',
        desc: '메인넷 & NKN 생태계 런칭'
      }
    },
    partnerTitle: '파트너와 연맹',
    exchangeTitle: 'Exchanges',
    texture: {
      text1: 'Free the bits,',
      text2: 'rebuild the Internet we always wanted'
    }
  },
  nMobileDownload: {
    nMobile: 'nMobile',
    powered: 'Powered by NKN',
    description: 'nMobile is secure mobile chat that eliminates the possibility of security and privacy breaches by removing centralized servers entirely.',
    userBenefits: 'User Benefits',
    extraSecureChat: 'Extra Secure Chat',
    security:{
      title: 'Security & Privacy Focused',
      item1:{
        title: 'Data Storage',
        detail: 'Only on your device, never in cloud',
      },
      item2:{
        title: 'No Central Server',
        detail: 'eliminates cloud database breaches',
      },
      item3:{
        title: '100% Open Source',
        detail: 'transparent, auditable, trusted',
      },
      item4:{
        title: 'Private Key',
        detail: 'Only on your device, never in cloud',
      },
      item5:{
        title: 'end-to-end Encryption',
        detail: 'no data is accessible in transit',
      },
    },
    secureChatCompared: {
      title: 'Secure Chat Compared',
      detail: '<p>nMobile is more secure than popular chat apps like WhatsApp and Signal. </p><br> <p>nMobile is <a target="_blank" class="link" href="https://github.com/nknorg/nMobile">Open Sourced!</a> Nothing to hide, and cannot be evil.</p>',
    },
    mobileCryptoWallet: {
      title: 'Mobile Crypto Wallet',
      subContent1: 'Manage NKN token balance and payments on the go (mainnet and ERC-20)',
      subContent2: 'Swap between Mainnet and ERC-20 NKN tokens (in future)'
    },
    securePrivateChat: {
      title: 'Secure & Private Chat',
      subContent1: 'Direct, end-to-end encrypted messaging.  No message is stored in the cloud.',
      subContent2: 'Chat between nMobile and D-Chat users. D-Chat  plugin available on',
      and: 'and',
      browsers: 'browsers.',
      Chrome: 'Chrome',
      FireFox: 'FireFox'
    },
    secureRemoteAccess: {
      title: 'Secure Remote Access (Coming Soon)',
      subContent1: 'Manage remote devices such as IoT, Security Cameras, or remote servers using secure messaging, tunnel and nShell.',
      subContent2: 'Secure and direct transfer of large files'
    },
    learnMore: {
      title: 'Learn More',
      item1: {
        title: 'nMobile: The Trusted Chat'
      },
      item2: {
        title: 'Introducing nMobile - Extra Secure Chat'
      }
    },
    download: 'Download',
    wxtips: 'Click on the upper right corner and select open in browser',
    ScanToDownload: 'Scan to Download',
    DownloadFor: 'Download for',
    production: 'Production',
    beta: 'Beta'
  },
  nMobileProDownload: {
    nMobile: 'nMobile Pro',
    powered: 'Powered by NKN',
    description: 'nMobile Pro adds a series of commercial functions such as nCDN and nConnect on the basis of nMobile. Apart from secure and private communication, it also guarantees a whole bunch of daily conveniences offered by NKN.',
    userBenefits: 'User Benefits',
    extraSecureChat: 'nMobile Commercial',
    security:{
      title: 'Security & Privacy Focused',
      item1:{
        title: 'Data Storage',
        detail: 'Only on your device, never in cloud',
      },
      item2:{
        title: 'No Central Server',
        detail: 'eliminates cloud database breaches',
      },
      item3:{
        title: '100% Open Source',
        detail: 'transparent, auditable, trusted',
      },
      item4:{
        title: 'Private Key',
        detail: 'Only on your device, never in cloud',
      },
      item5:{
        title: 'end-to-end Encryption',
        detail: 'no data is accessible in transit',
      },
    },
    secureChatCompared: {
      title: 'Secure Chat Compared',
      detail: '<p>nMobile is more secure than popular chat apps like WhatsApp and Signal. </p><br> <p>nMobile is <a target="_blank" class="link" href="https://github.com/nknorg/nMobile">Open Sourced!</a> Nothing to hide, and cannot be evil.</p>',
    },
    mobileCryptoWallet: {
      title: 'Mobile Crypto Wallet',
      subContent1: 'Manage NKN token balance and payments on the go (mainnet and ERC-20)',
      subContent2: 'Swap between Mainnet and ERC-20 NKN tokens (in future)'
    },
    securePrivateChat: {
      title: 'Secure & Private Chat',
      subContent1: 'Direct, end-to-end encrypted messaging.  No message is stored in the cloud.',
      subContent2: 'Chat between nMobile and D-Chat users. D-Chat  plugin available on',
      and: 'and',
      browsers: 'browsers.',
      Chrome: 'Chrome',
      FireFox: 'FireFox'
    },
    secureRemoteAccess: {
      title: 'Secure Remote Access (Coming Soon)',
      subContent1: 'Manage remote devices such as IoT, Security Cameras, or remote servers using secure messaging, tunnel and nShell.',
      subContent2: 'Secure and direct transfer of large files'
    },
    learnMore: {
      title: 'Learn More',
      item1: {
        title: 'nMobile: The Trusted Chat'
      },
      item2: {
        title: 'Introducing nMobile - Extra Secure Chat'
      }
    },
    download: 'Download',
    wxtips: 'Click on the upper right corner and select open in browser',
    ScanToDownload: 'Scan to Download',
    DownloadFor: 'Download for',
    production: 'Production',
    beta: 'Beta'
  },
})



// WEBPACK FOOTER //
// ./src/i18n/kr.js